import { createContext, FC, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext, UserSessionContext } from './AuthServiceProvider';
import Console from '../../pages/agent/ConsolePage';

// eslint-disable-next-line import/no-unused-modules
export const TokenContext = createContext('token_context_not_initialized');

const ProtectedRoutes: FC = () => {
    const providedUser = useContext(UserSessionContext);
    const userManager = useContext(AuthContext);
    const location = useLocation();
    
    useEffect(
        () => {
            userManager.getUser().then(user => {
                if (!user || user.expired) {
                    sessionStorage.setItem('returnUrl', location.pathname);
                    userManager.signinRedirect();
                }
            });
        },
        [location.pathname, userManager],
    );

    return (providedUser && !providedUser.expired)
        ? (
            <TokenContext.Provider value={providedUser.access_token}>
                <Console />
            </TokenContext.Provider>
        )
        : <label>Authenticating</label>

};

export default ProtectedRoutes;